(() => {
  if (customElements.get('accordion-element')) {
    return;
  }

  class AccordionElement extends HTMLElement {
    static ACTIVE_CLASS = 'is-open';

    constructor() {
      super();

      this.onSummaryClick = this.onSummaryClick.bind(this);
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    attachEvents() {
      this.summaryElement?.addEventListener('click', this.onSummaryClick);
    }

    detachEvents() {
      this.summaryElement?.removeEventListener('click', this.onSummaryClick);
    }

    init() {
      this.detailsElement = this.querySelector('details');
      this.summaryElement = this.detailsElement?.querySelector('summary');

      this.group = this.trigger?.closest('[data-accordion-group]');
    }

    onSummaryClick(event) {
      const isOpen = this.detailsElement.hasAttribute('open');

      event.preventDefault();

      isOpen
        ? this.close()
        : this.open();
    }

    open() {
      setTimeout(() => {
        this.detailsElement.classList.add(AccordionElement.ACTIVE_CLASS);
      });

      this.detailsElement.open = true;

      this.summaryElement.setAttribute('aria-expanded', true);

      this.dispatchEvent(new CustomEvent('accordion:open', { bubbles: true }));
    }

    close() {
      this.detailsElement.classList.remove(AccordionElement.ACTIVE_CLASS);

      this.summaryElement.setAttribute('aria-expanded', false);

      this.closeAnimation();

      this.dispatchEvent(new CustomEvent('accordion:close', { bubbles: true }));
    }

    closeAnimation() {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          this.detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }

  customElements.define('accordion-element', AccordionElement);
})();
